<!--
 * @Descripttion: 
 * @version: 
 * @Author: gaolongzhi
 * @Date: 2020-04-01 11:29:10
 * @LastEditors: gaolongzhi
 * @LastEditTime: 2020-09-08 13:56:01
--> 
<template>
  <div class="addCardPage">
    <job-header-simple header_title="添加银行卡"></job-header-simple>
    <van-cell-group style="margin: 10px 0;">
      <van-field readonly label="姓名" :value="ruleForm.userName" />
    </van-cell-group>
    <van-cell-group>
      <van-field readonly label="所在城市" :value="ruleForm.cityName" />
      <van-field readonly label="发卡银行" :value="ruleForm.bankName" />
      <van-field v-model="account" readonly label="银行卡号" />
    </van-cell-group>

    <div class="bottom">
      <van-button type="warning" round @click="$router.go(-1)">取消</van-button>
      <van-button type="info" :loading="loading" round class="btn_theme" @click="handleAdd">确认提交</van-button>
    </div>
  </div>
</template>
<script>
import { Field, Button, Cell, CellGroup, Toast } from "vant";
import jobHeaderSimple from "@/components/header/header.vue";
import store from "@/store";
import api from "@/api/list";
export default {
  components: {
    [Field.name]: Field,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Toast.name]: Toast,
    jobHeaderSimple,
  },
  data() {
    return {
      loading: false,
      types: "",
      ruleForm: {
        userName: store.getters.jwtDecode.name,
        bankName: this.$route.query.name,
        account: this.$route.query.code.account,
        cityName: this.$route.query.code.cityName,
      },
      account: this.$route.query.code.account,
      value: "",
      card_no: "",
      card_no2: "",
      showPicker: false,
      columns: [],
    };
  },
  created() {
    this.account = this.account.replace(/....(?=.)/g, "$& ");
  },
  methods: {
    handleAdd() {
      this.loading = true;
      let addr = this.ruleForm.cityName.split("/");
      let params = {
        userName: this.ruleForm.userName,
        bankName: this.ruleForm.bankName,
        account: this.ruleForm.account,
        provinceName: addr[0],
        cityName: addr[1],
      };
      api
        .bankCardSave(params, { method: "post" })
        .then((res) => {
          if (res.data.status == "200") {
            Toast.success("已成功添加");
            if (typeof this.$route.query.type != "undefined") {
              this.types = this.$route.query.type;
            }
            this.$router.push({
              path: "/card",
              query: {
                type: this.types,
                contractId: this.$route.query.obj,
              },
            });
          } else {
            Toast.fail(res.data.message);
          }
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          Toast.fail(error.response.message);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.addCardPage {
  .bottom {
    padding: 40px 0;
    .van-button {
      width: 40%;
      margin: 0 5%;
    }
  }
}
</style>


